import { useState } from 'react';
import { faqs } from '@/mocks/home';

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>('f1');

  return (
    <section id="faq" className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
        {/* sticky heading */}
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <span className="text-xs font-label text-secondary-600 tracking-[0.2em]">FAQ</span>
            <h2 className="mt-2 font-heading font-bold text-foreground-950 text-2xl md:text-3xl tracking-tight leading-snug">
              听之前，
              <br />
              你可能想知道这些
            </h2>
            <p className="mt-3 text-sm font-label text-foreground-600 leading-relaxed">
              关于音质、版本差异和播放方式，这里统一说清楚。
            </p>
            <div className="mt-6 inline-flex items-center gap-2 px-3.5 py-2.5 rounded-md bg-secondary-100 text-secondary-800 text-xs font-label">
              <i className="ri-information-line text-base"></i>
              还有别的问题？页面底部可以留言
            </div>
          </div>
        </div>

        {/* accordion */}
        <div className="lg:col-span-8">
          <div className="rounded-lg border border-background-200 overflow-hidden bg-background-50">
            {faqs.map((item, index) => {
              const isOpen = openId === item.id;
              return (
                <div key={item.id} className={index > 0 ? 'border-t border-background-200' : ''}>
                  <button
                    type="button"
                    onClick={() => setOpenId(isOpen ? null : item.id)}
                    className="w-full flex items-center gap-4 text-left px-4 md:px-6 py-4 md:py-5 cursor-pointer hover:bg-background-100/60 transition-colors"
                  >
                    <span className="text-xs font-label text-foreground-400 shrink-0">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                    <span className="flex-1 font-heading font-semibold text-foreground-950 text-sm md:text-base">
                      {item.q}
                    </span>
                    <span
                      className={`w-7 h-7 shrink-0 rounded-md flex items-center justify-center transition-colors ${
                        isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                      }`}
                    >
                      <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-4 md:px-6 pb-5 pl-12 md:pl-16 animate-fade-up">
                      <p className="text-xs md:text-sm font-label text-foreground-600 leading-relaxed">
                        {item.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}